import AsyncStorage from "@react-native-async-storage/async-storage";
import React, { useEffect, useState } from "react";
import {
  Text,
  TouchableOpacity,
  View,
  Image,
  ActivityIndicator,
  Dimensions,
  FlatList,
} from "react-native";
import api from "../../services/api";
import { FormattedMessage } from "react-intl";
import { If, Then, Else } from "react-if";
import { Feather } from "@expo/vector-icons";
import styles from "./styles";
import activesService from "../../services/activesService";
import { formatGPXBalance, maxDecimals } from "../../utils/formatNumber";
import PieChart from "react-native-pie-chart";
const colorPalette = [
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
  '#c0c0c0c',
];
const Header = () => {
  const [saldo, setSaldo] = useState(0);
  const [showBalance, setShowBalance] = useState(true);
  const [loading1, setLoading1] = useState(false);
  const [listActives, setListActives] = useState([]);
  const [lastQuote, setLastQuote] = useState("0.00");
  const [totalValue, setTotalValue] = useState(0);
  const [percentages, setPercentages] = useState({ saldo: 0, actives: [] });
  const [clientCountry, setClientCountry] = useState(null);
  const [lang, setLang] = useState("");
  const [translations, setTranslations] = useState({});
  const [loading, setLoading] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(4);
  const totalPages = Math.ceil(listActives.length / itemsPerPage);
  const [totalActives, setTotalActives] = useState(0);
  const widthAndHeight = 260;
  const smallWidthAndHeight = 200;
  const [isSmallScreen, setIsSmallScreen] = useState(
    Dimensions.get("window").width < 768
  );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentActives = listActives
    .slice(indexOfFirstItem, indexOfLastItem)
    .map((item) => {
      let color = "#ccc";

      if (item.name_token.includes("I-REC")) {
        color = "#FBB03B";
      } else if (item.name_token.includes("Selo")) {
        color = "#168673";
      } else if (item.name_token.includes("LTT")) {
        color = "#5271FF";
      }
      return {
        ...item,
        color: color,
      };
    });

  useEffect(() => {
    const handleResize = () => {
      const width = Dimensions.get("window").width;
      setIsSmallScreen(width < 768);
    };

    const subscription = Dimensions.addEventListener("change", handleResize);
    return () => {
      subscription?.remove();
    };
  }, []);

  const getSliceColors = () => {
    return percentages.actives.map((active, index) => {
      const item = listActives[index];
      if (!item) {
        return "#ccc";
      }

      if (item.name_token.includes("I-REC")) {
        return "#FBB03B";
      } else if (item.name_token.includes("Selo")) {
        return "#168673";
      } else if (item.name_token.includes("LTT")) {
        return "#5271FF";
      }
      // hotfix by fred: tá quebrando em homol

      return colorPalette[index % colorPalette.length];
    });
  };

  //Porcentagens de ativos na carteira para gráfico
  useEffect(() => {
    if (percentages.actives.length > 0) {
      const data = percentages.actives.map((active) => ({
        name: active.id,
        population: active.percentage,
        color: `#${Math.floor(Math.random() * 16777215).toString(16)}`,
        legendFontColor: "#7F7F7F",
        legendFontSize: 15,
      }));
      setChartData(data);
    }
  }, [percentages.actives]);

  const getBalanceCoin = async () => {
    const token = await AsyncStorage.getItem("JWT_TOKEN");
    setLoading(true);
    try {
      const res = await api.get("balanceGpxcoin", {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data.balance[0].available_balance) {
        setSaldo(res.data.balance[0].available_balance);
      } else {
        setSaldo(res.data.balance[0].saldo);
      }
    } catch (error) {
      console.error("Error fetching balance", error);
    } finally {
      setLoading(false);
    }
  };

  const getTokens = async () => {
    setLoading(true);
    const authToken = await AsyncStorage.getItem("JWT_TOKEN");
    try {
      const response = await activesService.getActivesWhereUserHasBalance(
        authToken
      );

      if (response.data.length > 0) {
        const filteredActives = response.data.filter((active) => {
          return (
            active.adoption !== true &&
            !(clientCountry !== "brasil" && active.category_name === "I-REC")
          );
        });

        setListActives(filteredActives);
      }
    } catch (error) {
      console.error("Error fetching tokens", error);
    }
    setLoading(false);
  };

  const getLang = async () => {
    const language = await AsyncStorage.getItem("lang");
    setLang(language || "pt-BR");
  };

  const translate = async (text, lang) => {
    if (text.includes("USE")) return text;
    if (lang === "pt-BR") return text;

    try {
      const token = await AsyncStorage.getItem("JWT_TOKEN");
      const response = await api.post(
        `/language-translation`,
        { text, target_language: lang },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response?.data?.translation || text;
    } catch (error) {
      console.error("Error translating text", error);
      return text;
    }
  };

  const getTranslations = async (actives) => {
    const translations = {};
    for (const item of actives) {
      if (!translations[item.id]) {
        translations[item.id] = await translate(item.name_token, lang);
      }
    }
    setTranslations(translations);
  };

  const getTokenValue = (token) => {
    if (lastQuote && parseFloat(lastQuote + "") > 0) {
      return Math.min(parseFloat(token.single_value), parseFloat(lastQuote));
    }
    if (token.single_value) {
      return parseFloat(token.single_value);
    }
    return 0.0;
  };

  const calculateTotalValue = () => {
    let totalActivesValue = 0;
    let activesValues = [];
    let totalBalance = 0;

    listActives.forEach((item) => {
      const tokenValue = getTokenValue(item);
      let balance = maxDecimals(item.balance, 0);
      balance = Math.floor(balance);
      const value = balance * tokenValue;
      totalActivesValue += value;
      totalBalance += balance;
      activesValues.push({ id: item.id, value });
    });

    const total = totalActivesValue + saldo;
    setTotalValue(total);
    setTotalActives(totalBalance);

    // Calculate percentages
    const saldoPercentage = calculatePercentage(saldo, total);
    const activesPercentages = activesValues.map((item) => ({
      id: item.id,
      percentage: calculatePercentage(item.value, total),
    }));

    setPercentages({ saldo: saldoPercentage, actives: activesPercentages });
  };

  const fetchCountryAndLang = async () => {
    const country = await AsyncStorage.getItem("client_country");
    const language = await AsyncStorage.getItem("lang");
    setClientCountry(country);
    setLang(language || "pt-BR");
  };

  useEffect(() => {
    fetchCountryAndLang();
  }, []);

  useEffect(() => {
    if (clientCountry) {
      getTokens();
      getBalanceCoin();
    }
  }, [clientCountry]);

  useEffect(() => {
    if (listActives.length > 0) {
      getTranslations(listActives);
    }
  }, [listActives, lang]);

  useEffect(() => {
    if (!loading) {
      calculateTotalValue();
      setLoading(false);
    }
  }, [loading, listActives]);

  const calculatePercentage = (value, total) => {
    if (total === 0) return 0;
    return (value / total) * 100;
  };

  if (loading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#077A97" />
      </View>
    );
  }

  return (
    <View style={styles.mainContainer}>
      <View style={styles.contentContainer}>
        <View>
          <View style={styles.containerTitleEye}>
            <Text style={styles.saldoTotalAtivos}>
              <FormattedMessage id="header.saldoTotalAtivos" />
            </Text>
            <View>
              <TouchableOpacity
                onPress={() => setShowBalance(!showBalance)}
                style={styles.toggleButton}
              >
                <If condition={showBalance}>
                  <Then>
                    <Feather name="eye-off" size={20} color="#077A97" />
                  </Then>
                  <Else>
                    <Feather name="eye" size={20} color="#077A97" />
                  </Else>
                </If>
              </TouchableOpacity>
            </View>
          </View>

          <View style={styles.containerSaldo}>
            <Text style={styles.textTotalAtivos}>
              <FormattedMessage id="header.mensagemSeuSaldo" />
            </Text>
            <If condition={showBalance}>
              <Then>
                <Text
                  style={[
                    styles.textTotalAtivos,
                    { flexShrink: 1, maxWidth: "100%" },
                  ]}
                >
                  {formatGPXBalance(totalValue)}
                </Text>
              </Then>
              <Else>
                <Text>************</Text>
              </Else>
            </If>
          </View>

          <View style={styles.containerAtivos}>
            <View style={styles.containerRow}>
              <Image
                source={require("../../../assets/logo-credito-carbono.png")}
                style={styles.img}
              />

              <View>
                <Text style={styles.ativos}>
                  <FormattedMessage id="header.mensagemSeuSaldo" />
                </Text>
                <If condition={showBalance}>
                  <Then>
                    <View style={{ flexDirection: "row" }}>
                      <Text style={styles.saldoAtivos}>
                        {formatGPXBalance(saldo)}{" "}
                      </Text>
                      <Text style={{ ...styles.saldoAtivos, color: "#7E7979" }}>
                        ({percentages.saldo.toFixed(2)}%)
                      </Text>
                    </View>
                  </Then>
                  <Else>
                    <Text>************</Text>
                  </Else>
                </If>
              </View>
            </View>
          </View>

          <View style={styles.container}>
            <FlatList
              data={currentActives}
              keyExtractor={(item) => item.id.toString()}
              renderItem={({ item }) => {
                const formattedBalance = formatGPXBalance(
                  maxDecimals(item.balance, 0) * getTokenValue(item)
                );
                const activePercentage = percentages.actives.find(
                  (active) => active.id === item.id
                )?.percentage;

                const imagemAtivo =
                  "https://filesgpx.s3.us-east-2.amazonaws.com/" + item.path;

                return (
                  <View style={styles.containerAtivos} key={item.id}>
                    <If condition={item.path}>
                      <Then>
                        <Image
                          source={{ uri: imagemAtivo }}
                          style={styles.img}
                        />
                      </Then>
                      <Else>
                        <Image
                          source={require("../../../assets/home/icons/logo.png")}
                          style={styles.img}
                        />
                      </Else>
                    </If>
                    <View style={styles.containerColumn}>
                      <Text style={styles.ativos}>
                        {Dimensions.get("window").width < 768
                          ? (translations[item.id] || item.name_token).replace(
                              /(.{1,20})(\s|$)/g,
                              "$1\n"
                            )
                          : translations[item.id] || item.name_token}
                      </Text>
                      <If condition={showBalance}>
                        <Then>
                          <View style={{ flexDirection: "row" }}>
                            <Text style={styles.saldoAtivos}>
                              {formattedBalance}{" "}
                            </Text>{" "}
                            <Text style={styles.saldoAtivos}>
                              <FormattedMessage id="header.mensagemSeuSaldo" />
                            </Text>
                            <Text
                              style={{
                                ...styles.saldoAtivos,
                                color: "#7E7979",
                              }}
                            >
                              ({activePercentage?.toFixed(2)}%)
                            </Text>
                          </View>
                        </Then>
                        <Else>
                          <Text>************</Text>
                        </Else>
                      </If>
                    </View>
                  </View>
                );
              }}
            />
          </View>
        </View>
      </View>
      {/* Visualziação do gráfico de ativos */}
      <View
        style={[
          styles.chartContainer,
          isSmallScreen && { marginTop: 20, alignItems: "center" },
        ]}
      >
        <If condition={percentages.actives.length > 0}>
          <Then>
            <View style={{ alignItems: "center" }}>
              <Text style={styles.graphTitle}>
                <FormattedMessage id="header.lblGrafico" />
              </Text>
              <View style={{ position: "relative" }}>
                <PieChart
                  widthAndHeight={
                    isSmallScreen ? smallWidthAndHeight : widthAndHeight
                  }
                  series={percentages.actives.map(
                    (active) => active.percentage
                  )}
                  sliceColor={getSliceColors()}
                  coverRadius={0.6}
                  coverFill={"#FFF"}
                  strokeWidth={5}
                  strokeColor={"#FFFFFF"}
                />
                <View
                  style={{
                    width: "100%",
                    position: "absolute",
                    top: "45%",
                    left: "15%",
                    transform: [
                      { translateX: -widthAndHeight * 0.15 },
                      { translateY: -widthAndHeight * 0.05 },
                    ],
                  }}
                >
                  <Text style={styles.txtMioloGraph}>{totalActives}</Text>
                  <Text style={[styles.txtMioloGraph, { fontSize: 16 }]}>
                    <FormattedMessage id="graph.lblTokensdeAtivos" />
                  </Text>
                </View>
              </View>
              <View style={styles.legendContainer}>
                <Text style={styles.legendaGrafico}>
                  <FormattedMessage id="graph.coresPorCategoria" />
                </Text>
                <FlatList
                  data={currentActives}
                  keyExtractor={(item) => item.id.toString()}
                  renderItem={({ item, index }) => (
                    <View style={styles.legendItem} key={item.id}>
                      <View
                        style={[
                          styles.legendColorBox,
                          { backgroundColor: item.color },
                        ]}
                      />
                      <Text style={styles.legendText}>
                        {translations[item.id] || item.id}
                        {/* <Text style={{ color: "#7E7979" }}>
                        ({item.percentage.toFixed(2)}%)
                      </Text> */}
                      </Text>
                    </View>
                  )}
                />
              </View>
            </View>
          </Then>
          <Else>
            <Text>
              <FormattedMessage id="header.graficoNenhumAtivo" />
            </Text>
          </Else>
        </If>
      </View>

      {/* Controles de navegação */}
      <View style={styles.paginationControls}>
        <TouchableOpacity
          onPress={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          style={
            currentPage === 1
              ? styles.paginationButtonDisabled
              : styles.paginationButton
          }
        >
          <Feather name="chevron-left" size={24} color="#fff" />
        </TouchableOpacity>

        <View style={styles.paginationDotsContainer}>
          {Array.from({ length: totalPages }).map((_, index) => (
            <View
              key={index}
              style={[
                styles.paginationDot,
                {
                  backgroundColor:
                    currentPage === index + 1 ? "#077A97" : "#7E7979",
                },
              ]}
            />
          ))}
        </View>

        <TouchableOpacity
          onPress={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          style={
            currentPage === totalPages
              ? styles.paginationButtonDisabled
              : styles.paginationButton
          }
        >
          <Feather name="chevron-right" size={24} color="#fff" />
        </TouchableOpacity>
      </View>
    </View>
  );
};

export default Header;
